"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var App_1 = require("../../App");
var LT_1 = require("../styles/LT");
/**
 * A large text input component that supports both regular and Firebase-backed state management.
 *
 * When using with Firebase, the component will automatically handle throttled updates to the specified
 * it also automatically fetches the document.
 *@example
 *
 * <LargeTextInput
 *   firebase
 *   path="profile/bio"
 *   placeholder="Tell us about yourself..."
 *   throttle={500}
 * />
 *
 * @param {Object} props - The properties for the component.
 * @param {string} [props.placeholder=""] - The placeholder text for the input.
 * @param {boolean} [props.firebase=false] - If true, the component will manage state through Firestore.
 * @param {string} [props.path] - The Firestore path to use when firebase is true. Required if firebase is true.
 * @param {string} [props.state] - The state value when firebase is false. Required if firebase is false.
 * @param {Function} [props.setState] - The state update function when firebase is false. Required if firebase is false.
 * @returns {ReactElement} The rendered LargeTextInput component.
 */
var LargeTextInput = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? "" : _b, _c = _a.firebase, firebase = _c === void 0 ? false : _c, props = __rest(_a, ["placeholder", "firebase"]);
    var _d = (0, App_1.useEloise)(), theme = _d.theme, logic = _d.logic;
    if (firebase) {
        var _e = props, path = _e.path, throttle = _e.throttle;
        var _f = logic.fb.hooks.useThrottleChange(path), value = _f[0], setValue_1 = _f[1];
        var handleInputChange = function (e) {
            setValue_1(e.target.value);
        };
        return (react_1.default.createElement(LT_1.LargeTextInputWrapper, null,
            react_1.default.createElement(LT_1.StyledTextArea, __assign({}, props, { value: value, onChange: handleInputChange, placeholder: placeholder, style: props.height ? { height: props.height } : {} }))));
    }
    else {
        var _g = props, state = _g.state, setState_1 = _g.setState;
        var handleInputChange = function (e) {
            setState_1(e.target.value);
        };
        return (react_1.default.createElement(LT_1.LargeTextInputWrapper, null,
            react_1.default.createElement(LT_1.StyledTextArea, __assign({}, props, { value: state, onChange: handleInputChange, placeholder: placeholder }))));
    }
};
exports.default = LargeTextInput;
